import { IonImg, IonFooter, IonList, IonSegmentButton, IonSegment, IonActionSheet, IonRouterLink, IonSpinner, IonApp, IonContent, IonPage, IonHeader, IonTitle, IonButtons, IonModal, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { trashOutline, copyOutline, banOutline, thumbsUpOutline, alertCircleOutline, close, arrowRedoOutline, thumbsUpSharp, thumbsDownSharp, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState }  from 'react';
import { Dialog, ConfirmResult } from '@capacitor/dialog';
import { Clipboard } from '@capacitor/clipboard';

import { CommentInfo, CommentLikeDetail } from "../data/item";
import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import CommentLike from "../components/CommentLike";

import '../pages/Main.css'; 
import '../pages/ChatMsg.css';

interface CommentProp {
    comment: CommentInfo;
    onUpdate : any;
    onUser: any;
    onReply: any;
}

const Comment : React.FC<CommentProp> = ({ comment, onUpdate, onUser, onReply }) => {
    
    const [menu, openMenu] = useState(false);
    const [showLikes, showLikeMenu] = useState(false);
    const [likeView, setLikeView] = useState("all");
    const [likeDetail, setLikeDetail] = useState<CommentLikeDetail[]>([]);
    const router = useIonRouter();

    // like a comment
    const doLike = async (like : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            comment: comment.id,
            like: like
        }

		var server = new NServer();
        await server.sendForm("nc_comment_like", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // success, update UI
            onUpdate();
        }
    }

    // open popover
    const openPopover = () => {
        openMenu(true);
    }

    // report the post
    const reportPost = () => {
        openMenu(false);
        onUser(null);   // need to close the modal

        router.push("/report/" + comment.id + "/comment", "forward", "push");
    }

    // block the user
    const blockUser = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_BLOCK_CHAT_TITLE), GetStr(LANGUAGE.TXT_BLOCK_CHAT_DESC));
        if (accept.value)
        {
            doBlockUser();
        }
    }

    // block the user
    const doBlockUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: comment.user,
            type : "user"
        }

		var server = new NServer();
        await server.sendForm("block", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            onUser(null);   // need to close the modal
            router.push("/blocklist", "back", "pop");
        }
    }

    // copy the text
    const copyText = async () => {
        openMenu(false);

        await Clipboard.write({
            string: comment.comment
        });
        
    }

    // ask user to delete this comment
    const deleteComment = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_ASK_DEL_COMMENT), GetStr(LANGUAGE.TXT_ASK_DEL_COMMENT_DESC));
        if (accept.value)
        {
            doDeletComment();
        }
    }

    // delete the comment
    const doDeletComment = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            comment: comment.id
        }

		var server = new NServer();
        await server.sendForm("nc_del_comment", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // success, update UI
            onUpdate();
        }
    }

    // reply the comment
    const replyComment = () => {
        openMenu(false);
        // ask parent to make a reply
        onReply(comment);
    }

    // show 
    const showCommentLikes = () => {
        openMenu(false);

        // update
        changeLikeView(likeView);
        // show the menu
        showLikeMenu(true);
    }

    // retrieve the comment likes
    const getCommentLikes = async (view : number) => {
         // empty first
        setLikeDetail([]);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            comment: comment.id,
            view: view
        }

		var server = new NServer();
        await server.getList("nc_cmt_like_info", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // success, update UI
            setLikeDetail(server.data);
        }
    }

    // change the like views
    const changeLikeView = (v : string) => {
        if (v == "like")
            getCommentLikes(1);
        else if (v == "dislike")
            getCommentLikes(2);
        else
            getCommentLikes(0);

        setLikeView(v);
    }

    // when click on comment like user
    const clickCmtLikeUser = (cmt : CommentLikeDetail) => {
        showLikeMenu(false);

        onUser({
            user : cmt.user
        });
    }

    return (
        <div>
            {
                comment.type == 1 ?
            <IonItem className="comment-box" lines="none" color="none">
                <IonAvatar className="comment-avt" slot="start" onClick={ ()=>onUser(comment) }>
                    <img src={comment.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                </IonAvatar>
                <IonLabel className="comment-bubble ion-text-wrap ion-activatable ripple-parent" onClick={openPopover}>
                    <IonText>
                        <b>{comment.user_name}</b>
                        &nbsp;<img className={ comment.user_bm == 1 ? "bluemark" : "ion-hide"} src="/assets/img/bm.png" />
                        { GetStr(LANGUAGE.TXT_COM_REACT_1) }<b>{comment.comment}</b>{ GetStr(LANGUAGE.TXT_COM_REACT_2) }
                    </IonText>
                    <IonRippleEffect></IonRippleEffect>
                </IonLabel>
            </IonItem>
                :
            <IonItem className="comment-box" lines="none" color="none">
                <IonAvatar className="comment-avt" slot="start" onClick={ ()=>onUser(comment) }>
                    <img src={comment.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                </IonAvatar>
                <IonLabel className="comment-bubble ion-activatable ripple-parent" onClick={openPopover}>
                    <IonText>
                        <b>{comment.user_name}</b>
                        &nbsp;<img className={ comment.user_bm == 1 ? "bluemark" : "ion-hide"} src="/assets/img/bm.png" />
                    </IonText>
                    {
                        /* show reply if there any */
                        comment.reply_id >= 0 ?
                    <div className="reply-inside">
                        <IonText color="medium">
                            <b>{ comment.reply_user }</b>
                            <div className="reply-inside-comment">{ comment.reply_comment }</div>
                        </IonText>
                    </div>
                        :
                    <br />
                    }
                    {
                        comment.comment != "" && comment.comment != "Sent a gif react" ?
                    <IonText className="comment-text">{comment.comment}</IonText>
                        :
                    <div />
                    }
                    {
                        comment.image != "" ?
                    <IonImg className="comment-img" src={comment.image} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/gif_err.jpg' } }/>
                        :
                    <div />
                    }
                    <IonRippleEffect></IonRippleEffect>
                </IonLabel>
            </IonItem>
            }
            <div className="comment-bar">
                <div>
                    {
                        comment.owner_like != "" ?
                    <IonChip className="like-but ion-no-margin" color="none">
                        <IonAvatar className="like-avt" onClick={onUser}>
                            <img src={comment.owner_like} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                        </IonAvatar>
                        <IonIcon color="primary" icon={heart} />
                    </IonChip>
                        :
                    <div/>
                    }
                    <IonChip className="like-but" color="none" onClick={()=>doLike(1)}>
                        <IonIcon color={ comment.like_done == 1 ? "primary" : "medium" } icon={thumbsUpSharp} />
                        <IonLabel color={ comment.like_done == 1 ? "primary" : "medium" }><b>{ comment.likes }</b></IonLabel>
                    </IonChip>
                    <IonChip className="like-but" color="none" onClick={()=>doLike(2)}>
                        <IonIcon color={ comment.dislike_done == 1 ? "primary" : "medium" } icon={thumbsDownSharp} />
                        <IonLabel color={ comment.dislike_done == 1 ? "primary" : "medium" }><b>{ comment.dislikes }</b></IonLabel>
                    </IonChip>
                </div>
                <div slot="end" className="comment-time">{ comment.date }</div>
            </div>

            { /* menu */ }
            <IonActionSheet
                isOpen={menu}
                onDidDismiss={() => openMenu(false)}
                buttons={
                    comment.owned == 1 ?     /* own comment */
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_COMMENT_REPLY),
                        icon: arrowRedoOutline,
                        handler: replyComment
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COPY_TEXT),
                        icon: copyOutline,
                        handler: copyText
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COMMENT_LIKES),
                        icon: thumbsUpOutline,
                        handler: showCommentLikes
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_DEL_COMMENT),
                        icon: trashOutline,
                        handler: deleteComment
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } 
                    ]
                    :
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_COMMENT_REPLY),
                        icon: arrowRedoOutline,
                        handler: replyComment
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COPY_TEXT),
                        icon: copyOutline,
                        handler: copyText
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COMMENT_LIKES),
                        icon: thumbsUpOutline,
                        handler: showCommentLikes
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_REPORT_ADMIN),
                        icon: alertCircleOutline,
                        handler: reportPost
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_BLOCK_USER),
                        icon: banOutline,
                        handler: blockUser
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } 
                    ]
                }
                >
            </IonActionSheet>

            { /* Comment Likes panel */ }
            { /* super like info */ }
            <IonModal
                isOpen={showLikes}
                initialBreakpoint={ 1 }
                onDidDismiss={() => showLikeMenu(false)}>
                <div className="ion-page">
                    <IonHeader className="ion-no-border">
                        <IonToolbar id="modal">
                            <IonSegment value={likeView} onIonChange={ (e) => { changeLikeView(e.detail.value!) }}>
                                <IonSegmentButton value="all">
                                    <IonLabel color={ likeView=="all" ? "primary" : "medium" }>
                                        <b><small>{ GetStr(LANGUAGE.TXT_CMT_LIKE_ALL) }</small></b>
                                    </IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="like">
                                    <IonLabel color={ likeView=="like" ? "primary" : "medium" }>
                                        <b><small>{ GetStr(LANGUAGE.TXT_CMT_LIKE_LIKE) }</small></b>
                                    </IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="dislike">
                                    <IonLabel color={ likeView=="dislike" ? "primary" : "medium" }>
                                        <b><small>{ GetStr(LANGUAGE.TXT_CMT_LIKE_DISLIKE) }</small></b>
                                    </IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>
                        <IonList class="bg-transparent">
                            { 
                                likeDetail.map((m) => 
                                    <CommentLike key={m.id} like={m} onClick={clickCmtLikeUser} />
                                )
                            }
                        </IonList>
                    </IonContent>
                    <IonFooter>
                        <IonButton className="main-but ion-margin" expand="block" onClick={() => showLikeMenu(false)}>
                            { GetStr(LANGUAGE.TXT_CLOSE) }
                        </IonButton>
                    </IonFooter>
                </div>
            </IonModal>
        </div>
    );
};
  
export default Comment;